import AboutCarousel from './AboutCarousel';
import InlineSVG from '../../icons';
import PropTypes from 'prop-types';
import React from 'react';
import VideoOverlay from '../overlay/VideoOverlay';
import useIsMobile from './hooks/isMobile';

const AboutBlock = ({data, mobile}) => {
    const {rings, border, screens = [], phone, titleOne, titleTwo, titleThree, video, description} = data;
    const [showOverlay, setOverlay] = React.useState(false);
    const isMobile = useIsMobile(mobile);
    const ringImg = isMobile ? rings.mobileImage : rings.desktopImage;
    const phoneImg = isMobile ? phone.mobileImage : phone.desktopImage;

    let showVideo = false;
    if (video && video.type !== 'none') {
        showVideo = true;
    }
    
    const toggleOverlay = React.useCallback(() => {
        setOverlay(!showOverlay);
    }, [setOverlay, showOverlay]);
    
    return (
        <section className="about-block">
            <div className="container-fluid section">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <div className="phone-container">
                            <div className="rings" style={{backgroundImage: `url(${ringImg})`}} />
                            <AboutCarousel slides={screens} isMobile={isMobile} />
                            <img src={phoneImg} alt="phone" className="phone" />
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-5 col-md-offset-1">
                        <div className="content">
                            <h2>
                                {titleOne}<br/>
                                {titleTwo}<br/>
                                {titleThree}<br/>
                            </h2>
                            <p>{description}</p>
                            {showVideo ? (<div role="presentation" className="video-container" onClick={toggleOverlay}>
                                <div className="video-border" style={{backgroundImage: `url(${border})`}} />
                                <img src={video.desktopImage} alt="video-screen" />
                                <div className="hex-button-container">
                                    <InlineSVG
                                    name="hexButton"
                                    className="hexButton"
                                    viewBox="0 0 26.33 30.77"/>
                                    <span className="icon-play-triangle" />
                                </div>
                            </div>) : null}
                        </div>
                    </div>
                </div>
            </div>
            <InlineSVG name="slant" className="diagonal-clip" />
            {showVideo ? (
                <VideoOverlay show={showOverlay} video={video} close={toggleOverlay} />
            ) : null}
        </section>
    );
};
AboutBlock.propTypes = {
    data: PropTypes.object,
    mobile: PropTypes.bool
}

export default AboutBlock;
